import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField, FormControl, InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { loginFlagOff, passwordChange } from "../../redux/actions/User";
import toast from "react-hot-toast";
import Circularbar from "../../components/circularbar/Circularbar";
import { useTranslation } from "react-i18next";
import AuthLayout from "./Layout";

function ChangePassword() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isPasswordChangeRequesting, isPasswordChanged, isPasswordChangeTokenExpired, passChangeError } = useSelector((state) => state.User);
  const params = useParams();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [cPassword, setCPassword] = useState("");

  useEffect(() => {
    if (isPasswordChanged) {
      toast.success(t("views.changePassword.passwordChangeSuccess"));
      dispatch(loginFlagOff());
    }
    if(passChangeError) {
      let errMessage = t("views.changePassword.errorContactSupport")
      if(passChangeError?.response?.data?.message == 'passNotMatch'){
        errMessage = t("views.changePassword.passNotMatch")
      }else if(passChangeError?.response?.data?.message == 'tokenExpired'){
        errMessage = t("views.changePassword.tokenExpiredErr")
      }
      toast.error(errMessage);
    }
  }, [isPasswordChanged, isPasswordChangeTokenExpired, passChangeError]);

  const passwordSaveChanges = (e) => {
    e.preventDefault()
    dispatch(
      passwordChange({
        token: params.token,
        password,
        confirmPasswords: cPassword,
      })
    );
  };

  return (
    <>
      {isPasswordChangeRequesting && (
        <>
          <Box
            sx={{
              height: "100vh",
              width: "100vw",
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              zIndex: 10000,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Circularbar />
          </Box>
        </>
      )}
      <AuthLayout>
        <Typography textAlign="center" maxWidth="460px" variant="h3" sx={{
            color: "#016AFE"
        }}>VCPlayer</Typography>
        <Typography textAlign="center" maxWidth="460px" variant="h4" sx={{
            color: "#313031"
        }}>SIGNAGE</Typography>
        {isPasswordChanged ? (
          <>
            <Typography textAlign="center" sx={{color: "#313031"}}>{t("views.changePassword.passwordChangeSuccessNew")}</Typography>
            <Box>
              <Button variant={"contained"} onClick={() => navigate("/login")}>
                {t("views.changePassword.goToLogin")}
              </Button>
            </Box>
          </>
        ) : (
          <form onSubmit={passwordSaveChanges} style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            flexDirection: "column",
            marginTop: '20px',
            width: '100%',
            maxWidth: '460px'
          }}>
            <Typography textAlign="center" variant="subtitle1" sx={{color: "#313031"}}>{t("views.changePassword.changePassTitle")}</Typography>
            <FormControl sx={{ width: "100%", input: { color: "#313031" } }} variant={"standard"}>
              <InputLabel htmlFor="new-password">{t("views.changePassword.newPassword")}</InputLabel>
              <Input
                required
                id="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={showNewPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position={"end"}>
                    <IconButton arial-label="toggle password visiblity" onClick={() => setShowNewPassword(!showNewPassword)}>
                      {showNewPassword ? <VisibilityOff sx={{ color: "#551ffa" }} /> : <Visibility sx={{ color: "#551ffa" }} />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl sx={{ width: "100%", input: { color: "#313031" } }} variant={"standard"}>
              <InputLabel htmlFor="confirm-password">{t("views.changePassword.confirmPassword")}</InputLabel>
              <Input
                required
                id="confirm-password"
                value={cPassword}
                onChange={(e) => setCPassword(e.target.value)}
                type={confirmPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility" onClick={() => setConfirmPassword(!confirmPassword)}>
                      {confirmPassword ? <VisibilityOff sx={{ color: "#551ffa" }} /> : <Visibility sx={{ color: "#551ffa" }} />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Box>
              <Button type="submit" variant={"contained"}>
                {t("views.changePassword.changePassword")}
              </Button>
            </Box>
          </form>
        )}
      </AuthLayout>
    </>
  );
}

export default ChangePassword;
